export default __webpack_public_path__ + "static/media/banner_mobile.66803d1d.svg";